export const TERMS_OF_SERVICE = `Terms of Service (DishiStudio MVP) 
Last updated: 1st January, 2026 
 
1. Acceptance of Terms 
By accessing or using DishiStudio, you agree to be bound by these Terms of Service. If you do not agree, do not use the App. 
 
2. Description of the Service 
DishiStudio is a social food and wellness application that allows users to: 
• Log meals 
• Share meals with friends 
• Build and maintain daily streaks based on shared meals 
• View leaderboards and activity history 
 
The App is currently offered as a Minimum Viable Product (MVP). Features may change, break, or be removed at any time. 
 
3. Eligibility 
You must be at least 13 years old to use the App. By creating an account, you confirm that you meet this requirement. 
 
4. Accounts and Authentication 
• You are responsible for all activity under your account 
• You must provide accurate account information 
• You agree not to share access credentials 
 
We reserve the right to suspend accounts engaged in abuse, cheating, or manipulation of streaks or social features. 
 
5. Meal Sharing and Streaks 
• Streaks are calculated automatically based on shared meal activity 
• Streaks may reset if no qualifying activity occurs within a given day 
• Streak values are informational and have no monetary value 
 
We do not guarantee the accuracy, continuity, or permanence of streak data during the MVP phase. 
 
6. No Medical or Health Advice Disclaimer 
DishiStudio does not provide medical, nutritional, dietary, or health advice. 
• All content related to meals, streaks, or wellness features is provided for informational and social purposes only 
• The App is not a substitute for professional medical advice, diagnosis, or treatment 
• You should always seek the advice of a qualified healthcare provider with any questions regarding health or dietary conditions 
 
Use of the App does not create a doctor-patient or professional relationship of any kind. 
 
7. User Content 
You retain ownership of content you submit (e.g., meal names, descriptions, images). 
By submitting content, you grant DishiStudio a non-exclusive, royalty-free license to store, display, and process this content solely for operating and improving the App. 
 
8. Acceptable Use 
You agree not to: 
• Attempt to exploit, reverse-engineer, or disrupt the App 
• Manipulate streaks or activity data dishonestly 
• Harass or abuse other users 
• Use the App for unlawful purposes 
 
9. MVP Disclaimer 
The App is provided "as is" and "as available". As an MVP: 
• Downtime may occur 
• Features may behave unexpectedly 
• Data loss is possible 
 
You use the App at your own risk. 
 
10. Limitation of Liability 
To the fullest extent permitted by law, DishiStudio shall not be liable for indirect, incidental, or consequential damages arising from your use of the App. 
 
11. Termination 
We may suspend or terminate your account at any time for violation of these Terms or to protect the integrity of the platform. 
 
12. Changes to These Terms 
We may update these Terms periodically. Continued use of the App constitutes acceptance of the revised Terms. 
 
13. Contact 
For questions, contact: dishimember@gmail.com`;

export const PRIVACY_POLICY = `Privacy Policy (DishiStudio MVP) 
Last updated: 1st January, 2026 
 
1. Information We Collect 
We collect only what is necessary to operate the App: 
• Account information (email, username) 
• Meal data you log or share 
• Social interaction data (friends, streaks, shared meals) 
• Usage metadata (timestamps, actions) 
 
2. How We Use Your Information 
Your data is used to: 
• Provide meal logging and sharing features 
• Calculate streaks and leaderboards 
• Enable social interactions 
• Improve reliability, security, and performance 
 
3. Data Storage and Processing 
Data is stored using third-party infrastructure providers (e.g., hosting and database services). We take reasonable measures to protect your data. 
 
4. Data Sharing 
We do not sell personal data. 
Data is shared only: 
• With other users, as required by social features (e.g., shared meals, streaks) 
• With infrastructure providers strictly necessary to operate the App 
• When required by law 
 
5. Data Retention 
We retain your data while your account is active. You may request account deletion, after which associated personal data will be removed within a reasonable period. 
 
6. Your Rights 
Depending on your jurisdiction, you may have rights to access, correct, or delete your personal data. 
 
7. Children's Privacy 
The App is not intended for children under 13. We do not knowingly collect data from children. 
 
8. Changes to This Policy 
We may update this Privacy Policy as the App evolves. Updates will be posted in the App. 
 
9. Contact 
For privacy questions, contact: dishimember@gmail.com`;